import React, { FC, memo } from 'react'
import { SlugifiedAttributesFilterItemWithValues } from 'services/providers/bapi/entities/filters/normalize'
import BrandFilter from 'sharedComponents/ProductFilter/Filters/AttributeFilters/BrandFilter'
import ColorFilter from 'sharedComponents/ProductFilter/Filters/AttributeFilters/ColorFilter'
import { useIsCategoryClothing } from 'sharedComponents/ProductFilter/util/useIsCategoryClothing'
import {
  attributeFilterPropsAreEqual,
  useDisplaySizeFilter,
} from 'sharedComponents/ProductStream/helpers'
import GenericFilter from './AttributeFilters/GenericFilter'
import StyleFilter from './AttributeFilters/StyleFilter'

const AttributeFilter: FC<SlugifiedAttributesFilterItemWithValues> = memo(
  function AttributesFilter(filter) {
    const isCategoryClothing = useIsCategoryClothing()
    const shouldDisplaySizeFilter = useDisplaySizeFilter()

    switch (filter.slug) {
      case 'color':
        return <ColorFilter key={filter.slug} filter={filter} />
      case 'brand':
        return <BrandFilter key={filter.slug} filter={filter} />
      case 'styleGroup':
        return isCategoryClothing ? (
          <StyleFilter key={filter.slug} filter={filter} />
        ) : null
      case 'size':
      case 'categoryShopFilterSizes':
        return shouldDisplaySizeFilter ? (
          <GenericFilter filter={filter} />
        ) : null
      default:
        return <GenericFilter filter={filter} />
    }
  },
  attributeFilterPropsAreEqual,
)

export default AttributeFilter
